export default {
    name: 'สมชาย รักชาติ',
    subjects: [
        {
            code: 'ส22101',
            name: 'สังคมศึกษา ศาสนา และวัฒนธรรม 2',
            colors: ['#32529D', '#C5AACD'],
            courses: [
                {
                    id: '1',
                    name: 'เศรษฐศาสตร์',
                    description: 'แบบทดสอบหลังเรียน',
                    questionLength: 20
                }
            ]
        }
    ]
}